import { createSelector } from "reselect";

import SavedAddressType from "@mapmycustomers/shared/enum/SavedAddressType";

import { RootState } from "@app/store/rootReducer";
import { getSavedAddressById, getSavedAddresses } from "@app/store/savedLocations";

export const getSavedLocationCard = (state: RootState) => {
  const { card } = state.savedLocationsUi;
  return card && getSavedAddressById(state, card.id);
};

export const getSavedLocationNamingCard = createSelector(
  [(state: RootState) => state.savedLocationsUi.namingCard, getSavedAddresses],
  (namingCard, savedAddresses) => {
    if (!namingCard || namingCard.kind === "blocked") {
      return namingCard;
    }
    const savedAddress = savedAddresses.find(({ id }) => id === namingCard.id);
    // A row made Home or Work, here or elsewhere, has no name step left
    return savedAddress?.type === SavedAddressType.CUSTOM
      ? { kind: namingCard.kind, savedAddress }
      : undefined;
  }
);
